import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

Highcharts.setOptions({
    credits: { enabled: false },
    lang: {
      thousandsSep: ','
    }
  });
  
function GlobalValue({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let globalValue = foodAnswers.answerKeyValues['historical_global_value'];
	let globalValueYear = foodAnswers.answerKeyValues['historical_global_value_year'];
	let globalValueSourceRef = foodAnswers.answerKeyValues['historical_global_value_sources'];
	let globalValueNotes = foodAnswers.answerKeyValues['historical_global_value_notes'];
	
	let array = [];
	let dataSeries = [];
	let xAxisCategories = [];
	if(globalValue){
		try {
			array =  JSON.parse(globalValue);
		} catch (err) {
			console.log("GlobalValue :globalValue: " +err);
		}
		dataSeries = array.map(function(obj) {
			if (obj && obj["year"] && obj["value_current_million_us_"]) {
				return [parseInt(obj["year"]), parseFloat(obj["value_current_million_us_"].replace(/,/g, ''))];
			}
		});
		xAxisCategories = array.map(function (obj) {
			if (obj && obj["year"] ){
				return [parseInt(obj["year"])];
			}
		});
	}
	let titleText = '';
	if(dataSeries && dataSeries.length > 0 && dataSeries[0]){
		titleText = 'Historic Global Value of '+foodName;
	}
	
	return(
			<div>
				{(dataSeries && dataSeries.length > 0 && dataSeries[0]) ? <><h2 style={{textAlign: "center"}}>
					{titleText}
					{globalValueYear ? 
					<small>&nbsp;({globalValueYear})</small>
					: ""}
					{ globalValueSourceRef && globalValueSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+globalValueSourceRef}>{globalValueSourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					yAxis: {
						labels: {
							formatter: function() {
								return '$' + this.value + 'm';
							}
						},
						title: {
							text: "Value(current million US$)"
						},
						plotLines: [{
							value: 0,
							width: 1,
							color: '#808080'
						}]
					},
					xAxis: {
						categories: xAxisCategories,
						title: {
							text: ''
						}
					},
					tooltip: {
						valuePrefix: '$'
					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'right',
						verticalAlign: 'middle',
						borderWidth: 0
					},
					series: [{
						name: "Value(current million US$)",
						data: dataSeries
					}]
				}}
				/>
				{globalValueNotes  ? 
				<p className="notes-info" style={{marginTop: "-10px"}}>
				<em>{globalValueNotes}</em>
				</p>
				:""}
				</>:""}
			</div>
		)
}
export default GlobalValue;